// extracted by mini-css-extract-plugin
export var gif = "_il-0";